'use client';

import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';
import { isCapacitor } from '@/lib/platformUtils';
import { haptics } from '@/lib/haptics';
import UserDocsSheet from '@/components/shared/UserDocsSheet';

const USER_DOCS_BASE_URL =
  process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'
    ? 'https://user-docs.totalaccess.co.za'
    : 'https://dev-user-docs.totalaccess.co.za';

interface UserDocsLinkProps {
  docsPath: string;
  label?: string;
  className?: string;
}

export default function UserDocsLink({
  docsPath,
  label = 'Open the user guide',
  className = '',
}: UserDocsLinkProps) {
  const docsUrl = `${USER_DOCS_BASE_URL}${docsPath}`;
  const [sheetOpen, setSheetOpen] = useState(false);

  return (
    <>
      <a
        href={docsUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
        onClick={(e) => {
          e.stopPropagation();
          void haptics.light();
          // On the Capacitor app a target=_blank link bounces to the system
          // browser with no way back — open the docs in an in-app sheet instead.
          if (isCapacitor()) {
            e.preventDefault();
            setSheetOpen(true);
          }
        }}
        className={`group relative inline-flex shrink-0 items-center justify-center rounded-full text-gray-400 transition-colors hover:text-blue-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 ${className}`}
      >
        <HelpCircle className="h-4 w-4" />
        <span className="pointer-events-none absolute bottom-full left-1/2 z-50 mb-1.5 -translate-x-1/2 whitespace-nowrap rounded-md bg-gray-900 px-2 py-1 text-xs font-medium text-white opacity-0 shadow-lg transition-opacity group-hover:opacity-100 dark:bg-gray-700">
          {label}
        </span>
      </a>
      {sheetOpen && (
        <UserDocsSheet
          url={docsUrl}
          title={label}
          onClose={() => setSheetOpen(false)}
        />
      )}
    </>
  );
}
